import React, { useCallback, useEffect, useState } from "react";
import { Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { fetchSalesAvailability, updateSalesAvailability } from "./salesHandoffService";
import styles from "./intentInsights/intentInsights.module.scss";

export default function SalesAvailabilityPanel({ userId, onChanged }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchSalesAvailability();
      const ids = res?.sales_available_user_ids || [];
      setAvailable(Boolean(res?.sales_workspace_available) && ids.includes(String(userId)));
    } catch (_) {
      setAvailable(false);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    load();
  }, [load]);

  const onToggle = async (checked) => {
    try {
      await updateSalesAvailability({
        sales_workspace_available: checked,
        sales_available_user_ids: checked && userId ? [String(userId)] : [],
      });
      setAvailable(checked);
      message.success(
        checked
          ? t("sonic_prospect.sales_handoff.availability_on")
          : t("sonic_prospect.sales_handoff.availability_off"),
      );
      if (onChanged) onChanged();
    } catch (_) {
      message.error(t("sonic_prospect.sales_handoff.availability_error"));
    }
  };

  return (
    <div className={styles.salesAvailabilityPanel}>
      <p className={styles.salesAvailabilityLabel}>{t("sonic_prospect.sales_handoff.availability_title")}</p>
      <p className={styles.salesAvailabilityHint}>{t("sonic_prospect.sales_handoff.availability_hint")}</p>
      <Switch checked={available} loading={loading} onChange={onToggle} />
    </div>
  );
}
